import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30349b08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 mb-4" }
const _hoisted_4 = { class: "row row-document mb-3" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row row-show-file-details mb-4" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "row row-text mb-3" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "row row-button-text-layout mb-3" }
const _hoisted_12 = { class: "col-9" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "col-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_InputImage = _resolveComponent("InputImage")!
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Subtitle = _resolveComponent("Subtitle")!
  const _component_InputSelect = _resolveComponent("InputSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseSpinner, {
      spin: !_ctx.isReady
    }, null, 8, ["spin"]),
    (_ctx.isReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_InputImage, {
                    id: "file-input",
                    "onUpdate:modelValue": _ctx.setDocumentKey,
                    onImageCleared: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setDocumentKey(null))),
                    modelValue: _ctx.existingDocumentKey,
                    typeCode: _ctx.docType,
                    maxHeight: "100px",
                    module: _ctx.DpModuleEnum.CMS
                  }, null, 8, ["onUpdate:modelValue", "modelValue", "typeCode", "module"])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_InputCheckboxBoolean, {
                    modelValue: _ctx.contentBlock.is_show_file_details,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contentBlock.is_show_file_details) = $event)),
                      _ctx.onChange
                    ],
                    label: _ctx.$t('cms.showFileProperties'),
                    name: "showFileDetails",
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.contentBlock.title.nl,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contentBlock.title.nl) = $event)),
                        _ctx.onChange
                      ],
                      label: _ctx.$t('text'),
                      name: "text",
                      rules: "max:500",
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_Subtitle, {
                      help: _ctx.$t('cms.helpTextDocumentTitle'),
                      "help-position": "left",
                      mb: "3"
                    }, null, 8, ["help"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.contentBlock.button_text,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contentBlock.button_text) = $event)),
                        _ctx.onChange
                      ],
                      label: _ctx.$t('description'),
                      name: "description",
                      rules: "max:100",
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_Subtitle, {
                      help: _ctx.$t('cms.helpTextDocumentDescription'),
                      mb: "3"
                    }, null, 8, ["help"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_InputSelect, {
                    modelValue: _ctx.contentBlock.button_layout_code,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contentBlock.button_layout_code) = $event)),
                      _ctx.onChange
                    ],
                    options: _ctx.btnLayoutOptions,
                    label: _ctx.$t('layout'),
                    name: "buttonLayout",
                    selectText: _ctx.$t('selectText'),
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}